import { cachedGet } from './api';

export interface PlatformSettings {
  platform_name: string;
  platform_tagline: string | null;
  platform_description: string | null;
  support_email: string | null;
  support_phone: string | null;
  support_address: string | null;
  support_city: string | null;
  support_state: string | null;
  support_country: string | null;
  token_to_dollar_rate: number;
  currency_symbol: string;
  currency_code: string;
  min_token_purchase: number;
  max_token_purchase: number;
  enable_auctions: boolean;
  enable_games: boolean;
  enable_streaming: boolean;
  enable_advertising: boolean;
  enable_referrals: boolean;
  referral_bonus_amount: number;
  referral_bonus_for_referrer: number;
  maintenance_mode: boolean;
  maintenance_message: string | null;
  facebook_url: string | null;
  twitter_url: string | null;
  instagram_url: string | null;
  linkedin_url: string | null;
  youtube_url: string | null;
  meta_title: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  terms_url: string | null;
  privacy_url: string | null;
  logo_url: string | null;
  favicon_url: string | null;
  default_language: string;
  supported_languages: string[];
  // Help & Support Ticker
  enable_support_ticker: boolean;
  support_ticker_message: string | null;
  support_ticker_link: string | null;
  support_ticker_link_text: string | null;
  support_ticker_speed: 'slow' | 'normal' | 'fast';
  support_ticker_bg_color: string | null;
  support_ticker_text_color: string | null;
  enable_recaptcha: boolean;
  recaptcha_site_key: string | null;
}

const settingsService = {
  /**
   * Get public platform settings (no authentication required)
   */
  getPublicSettings: async (): Promise<PlatformSettings> => {
    return await cachedGet<PlatformSettings>('/public/settings');
  },
};

export default settingsService;
